// The sub-path the web build is served from (CHEFI_BASE, e.g. /chefi/ → 'chefi'), so routes
// match and links keep the prefix. Empty when hosted at the root.
export const basePath = (import.meta as unknown as { env: { BASE_URL: string } }).env.BASE_URL.replace(/^\/+|\/+$/g, '');
